
import { defineComponent } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";
import { code4 } from "@/views/resources/documentation/element-ui/basic/layout/code";

export default defineComponent({
  name: "column-offset",
  components: {
    CodeHighlighter
  },
  setup() {
    return {
      code4
    };
  }
});
